import {useEffect, useRef, useState} from 'react';
import parse from 'html-react-parser';
import {mrbgStore} from './mrbgRedux';
import {mrbgTools} from '../../mrbgLib/mrbgTools.js';

function MrbgTextEditor({formID,name,other,formStyle}){

	const
		mrbgTE = useRef(),
		fileInputRef = useRef(),
		[content, setContent] = useState(''),
		[micCls, setMicCls] = useState(formStyle.mrbgMicro+' fa-solid fa-microphone-slash'),
		[redFld, setRedFld] = useState(mrbgStore.getState().formsSettings[formID]?.redFld),
		placeholder = document.documentElement.getAttribute('lang') == 'fa'? 'لطفا متن را وارد کنید:': 'Please enter the text:';

	function listening( e ){
		e.preventDefault();
		if( mrbgTools.recog.listening ){
			mrbgTools.recog.stop()
			setMicCls(formStyle.mrbgMicro+' fa-solid fa-microphone-slash');
		}
		else if( micCls == formStyle.mrbgMicro+' fa-solid fa-microphone '+formStyle.activeMrbgMicro ){
			setMicCls(formStyle.mrbgMicro+' fa-solid fa-microphone-slash');
		}
		else{
			mrbgTools.recog.start();
			mrbgTools.recog.mrbgTI = mrbgTE.current;
			setMicCls(formStyle.mrbgMicro+' fa-solid fa-microphone '+formStyle.activeMrbgMicro);
		}
	}
	function keyDownHandler( e ){
		if( e.which == 13 ){
			var
				[range, parentNode] = mrbgTools.rng.getRange(mrbgTE.current),
				parentElm           = mrbgTools.rng.parentElement(parentNode),
				newNode;

			if( !parentElm.closest(`[class="${TE_style.mrbgList}"]`) ){
				e.preventDefault();
				newNode = document.createElement('br');
				mrbgTools.rng.newNode(range, newNode);
				mrbgTools.rng.setCursorByNode(newNode, true);
			}
		}
	}
	function stripTags( e ){
		e.preventDefault();
		var [range, parentNode] = mrbgTools.rng.getRange(mrbgTE.current);
		if( range == undefined ) return false;

		var rangeNewVal = '';

		const clipboardData = e.clipboardData || window.clipboardData;

		if( clipboardData.types.includes('text/html') ){
			const pastedHtml = clipboardData.getData('text/html');
			const parser     = new DOMParser();
			const doc        = parser.parseFromString(pastedHtml, 'text/html');
			const body       = doc.body;

			function processNode( node ){
				if( node.nodeType === Node.TEXT_NODE ){
					return node.textContent
						.replace(/\u00A0+/g, ' ')
						.replace(/[\u2022\u2023\u25E6\u25AA\u25AB\u25CF\u25CB\u2981]+/g, '');
				}
				else if( node.nodeType === Node.ELEMENT_NODE ){
					const
						tagName     = node.tagName.toUpperCase(),
						allowedTags = ['BR', 'I'];

					if( allowedTags.includes(tagName) || ( node.classList?.length && !Array.from(node.classList).some(c => !hashedClass.includes(c)) ) ){
						let content = '';
						for( let i = 0; i<node.childNodes.length; i++ ){
							if( allowedTags.includes(tagName) )
								node.childNodes[i].removeAttribute('style');
							content += processNode(node.childNodes[i]);
						}
						return `<${tagName} class="${Array.from(node.classList).join(' ')}">${content}</${tagName}>`;
					}
					else if( tagName === 'IMG' && node.getAttribute('src')?.startsWith(window.location.hostname) ){
						return `<img src="${node.getAttribute('src')}">`;
					}
					else{
						let content = '';
						for( let i = 0; i<node.childNodes.length; i++ )
							content += processNode(node.childNodes[i]);
						return content;
					}
				}
				return '';
			}

			const hashedClass = [];
			for( var c in TE_style )
				hashedClass.push(TE_style[c]);

			const comments = Array.from(body.childNodes);
			for( let i = comments.length-1; i>=0; i-- ){
				if( comments[i].nodeType === Node.COMMENT_NODE )
					comments[i].remove();
			}

			rangeNewVal = processNode(body);
		}
		else{
			rangeNewVal = clipboardData.getData('text/plain')
				.replace(/\u00A0+/g, ' ')
				.replace(/[\u2022\u2023\u25E6\u25AA\u25AB\u25CF\u25CB\u2981]+/g, '');
		}

		mrbgTools.rng.newValue(range, rangeNewVal);
		mrbgTools.rng.setCursorByRange(range);

		mrbgTE.current.normalize();
	}
	function warpper( e, tagName ){

		e.preventDefault();
		var
			[range, parentNode] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm           = mrbgTools.rng.parentElement(parentNode),
			newNode             = '',
			mrbgCls             = TE_style['mrbg'+tagName.substring(0, 1).toUpperCase()+tagName.substring(1)];

		if( range == undefined || ( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') ) )
			return false;

		mrbgTools.rng.fill(range);
		if( range.toString().trim() == '' )
			return false;
		parentElm = mrbgTools.rng.parentElement(range.commonAncestorContainer);

		if( parentElm.matches(`${tagName}[class="${mrbgCls}"]`) || parentElm.closest(`${tagName}[class="${mrbgCls}"]`) ){
			newNode =
				parentElm.matches(`${tagName}[class="${mrbgCls}"]`)?
				parentElm:
				parentElm.closest(`${tagName}[class="${mrbgCls}"]`);
			mrbgTools.rng.addNodeToRange(range, newNode);
			mrbgTools.rng.unWarpNode(range, newNode);
			mrbgTools.rng.setCursorByRange(range)
		}
		else{
			if( ['SPAN', 'EM', 'STRONG', 'I'].includes(parentElm.tagName) && parentElm.innerText == range.toString() ){
				while( ['SPAN', 'EM', 'STRONG', 'I'].includes(parentElm.parentElement.tagName) && parentElm.parentElement.innerText == range.toString() )
					parentElm = parentElm.parentElement;
				mrbgTools.rng.addNodeToRange(range, parentElm);
			}
			newNode = document.createElement(tagName);
			newNode.classList.add(mrbgCls);
			newNode.appendChild(range.cloneContents());

			mrbgTools.rng.newNode(range, newNode);
			mrbgTools.rng.setCursorByNode(newNode)
		}
	}
	function spanWarpper( e, className ){

		e.preventDefault();
		var
			[range, parentNode] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm           = mrbgTools.rng.parentElement(parentNode),
			newNode             = '';

		if( range == undefined || ( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') ) )
			return false;

		if( parentElm.tagName == 'SPAN' ){
			if( parentElm.classList.length == 1 && parentElm.classList.contains(TE_style[className]) ){
				mrbgTools.rng.addNodeToRange(range, parentElm);
				mrbgTools.rng.unWarpNode(range, parentElm);
				mrbgTools.rng.setCursorByRange(range)
			}
			else{
				parentElm.classList.contains(TE_style[className])?
				parentElm.classList.remove(TE_style[className]):
				parentElm.classList.add(TE_style[className]);
				mrbgTools.rng.setCursorByRange(range)
			}
		}
		else{
			mrbgTools.rng.fill(range);
			if( range.toString().trim() == '' )
				return false;

			newNode = document.createElement('span');
			newNode.classList.add(TE_style[className]);
			newNode.appendChild(range.cloneContents());

			mrbgTools.rng.newNode(range, newNode);
			mrbgTools.rng.setCursorByNode(newNode)
		}
	}
	function handleInputFile( e ){
		e.preventDefault();

		var
			[range, parentNode] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm           = mrbgTools.rng.parentElement(parentNode);

		if( range == undefined || ( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') ) )
			return false;

		if( parentElm !== mrbgTE.current ){
			alert(
				'Sorry!\n'+
				'To add an image to the content, the cursor must be placed directly within the editor\'s content area.\n'+
				'Images cannot be added if the cursor is located within a child element, in an undefined position, or outside of the text editor itself.'
			);
		}
		else
			fileInputRef.current.click();
	}
	function extraImage( e ){
		const
			file                = e.target.files[0],
			[range, parentNode] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm           = mrbgTools.rng.parentElement(parentNode);

		if(
			( !file || range === undefined ) ||
			( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') )
		)
			return false;

		var alt = prompt('please insert img description');

		const reader  = new FileReader();
		reader.onload = function( event ){
			const image  = new Image();
			image.src    = event.target.result;
			if( alt )
				image.alt = alt;

			image.onload = function(){
				var
					mrbgTE_height = mrbgTE.current.offsetHeight-20; // 20PX FOR VERTICAL PADDING

				const newNode = document.createElement('figure');
				newNode.classList.add(TE_style.extraImg);
				newNode.setAttribute('style', `width:${mrbgTE_height*.8*other.imgWidth/other.imgHeight}px`);
				newNode.appendChild(image);

				mrbgTools.rng.newNode(range, newNode);
				mrbgTools.rng.setCursorByNode(newNode, true);
			};
		};
		reader.readAsDataURL(file);
	}
	function icon( e ){
		e.preventDefault();
		var
			[range, parentNode] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm           = mrbgTools.rng.parentElement(parentNode);

		if( range == undefined || ( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') ) )
			return false;

		mrbgTools.rng.fill(range);
		if( range.toString().trim() == '' )
			return false;

		var className = range.toString().split(' ');
		if( className.length == 1 )
			className =
				!className[0].startsWith('fa-')?
					['fa-solid', 'fa-'+className[0]]:
					['fa-solid', className[0]];

		var newNode = document.createElement('i');
		newNode.classList.add(...className);

		mrbgTools.rng.newNode(range, newNode);
		mrbgTools.rng.setCursorByNode(newNode, true);
	}
	function linkTo( e, linkType ){
		e.preventDefault();
		var
			[range, parentNode] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm           = mrbgTools.rng.parentElement(parentNode),
			msg                 = {
				url: 'please insert a url',
				tel: 'please insert a phone number',
				mail: 'please insert a mail address',
			};

		if( range == undefined || ( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') ) )
			return false;

		var href = prompt(msg[linkType]);
		if( href == null || href.trim() == '' )
			return false;

		linkType == 'mail'?
		mrbgTools.rng.fill(range, true):
		mrbgTools.rng.fill(range);

		if( range.toString().trim() == '' )
			return false;

		// HREF _____________________________________________________________________
		if( linkType == 'tel' )
			href = `tel:${href}`;
		else if( linkType == 'mail' )
			href = `mailto:${href}`;

		// LINK TEXT ________________________________________________________________
		var
			linkText = range.toString().trim(' '),
			len      = linkText.length;

		if( /^(((\+|00)\d{1,3})|(\(\d{1,3}\))|0)(\s|\-)?\d{10,12}$/.test(linkText) )
			linkText =
				linkText.startsWith('0')?
				`${linkText.substring(0, 4)} ${linkText.substring(len-7, len-4)} ${linkText.substring(len-4, len)}`:
				`(${linkText.substring(0, len-10)}) ${linkText.substring(len-10, len-7)} ${linkText.substring(len-7, len-4)} ${linkText.substring(len-4, len)}`;

		else if( /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(linkText) )
			linkText = linkText.replace('@', '[a]');

		var parentElm = range.commonAncestorContainer;
		while( ['SPAN', 'EM', 'STRONG', 'I'].includes(parentElm.parentElement.nodeName) && parentElm.parentElement.innerText == range.toString() )
			parentElm = parentElm.parentNode;

		if( ['SPAN', 'EM', 'STRONG', 'I'].includes(parentElm.nodeName) ){
			mrbgTools.rng.addNodeToRange(range, parentElm);
			linkText = parentElm.outerHTML;
		}

		var newNode  = document.createElement('a');
		newNode.href = href;
		newNode.classList.add(TE_style.mrbgLink);
		newNode.innerHTML = linkText;

		mrbgTools.rng.newNode(range, newNode);
		mrbgTools.rng.setCursorByNode(newNode);
	}
	function unLink( e ){
		e.preventDefault();
		var
			[range, parentNode] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm           = mrbgTools.rng.parentElement(parentNode);

		if( range == undefined || ( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') ) )
			return false;

		if( parentElm.matches(`a[class="${TE_style.mrbgLink}"]`) || parentElm.closest(`a[class="${TE_style.mrbgLink}"]`) ){
			parentElm =
				parentElm.matches(`a[class="${TE_style.mrbgLink}"]`)?
				parentElm:
				parentElm.closest(`a[class="${TE_style.mrbgLink}"]`);
			mrbgTools.rng.addNodeToRange(range, parentElm);
			mrbgTools.rng.unWarpNode(range, parentElm);
			mrbgTools.rng.setCursorByRange(range)
		}
	}
	function listWarpper( e, listTagName ){
		e.preventDefault();
		var
			[range, parent] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm       = mrbgTools.rng.parentElement(parent),
			targetNode,
			newNode;

		if( range == undefined || ( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') ) )
			return false;

		if( parentElm.matches(`${listTagName}[class=${TE_style.mrbgList}]`) || parentElm.closest(`[class=${TE_style.mrbgList}]`) ){
			newNode = document.createDocumentFragment();

			targetNode =
				parentElm.matches(`[class=${TE_style.mrbgList}]`)?
				parentElm:
				parentElm.closest(`[class=${TE_style.mrbgList}]`);

			var
				temp = document.createElement('div'),
				br   = document.createElement('br');
			targetNode.querySelectorAll(':scope>li').forEach(li => {
				if( li.childNodes && li.childNodes[0].nodeName == '#text' )
					newNode.appendChild(br);
				temp.innerHTML = li.innerHTML;
				while( temp.firstChild )
					newNode.appendChild(temp.firstChild);
			});

			mrbgTools.rng.addNodeToRange(range, targetNode);
			mrbgTools.rng.newNode(range, newNode);
			mrbgTools.rng.setCursorByRange(range);
		}
		else{
			newNode = document.createElement(listTagName);
			newNode.classList.add(TE_style.mrbgList);
			if( listTagName == 'ol' ){
				newNode.type = 1;
				newNode.addEventListener('wheel', e => changeOlType(e));
				newNode.removeEventListener('wheel',changeOlType)
			}

			var
				liNode,
				rangeList = mrbgTools.rng.getParagraph(range);

			rangeList.forEach(rng => {
				liNode           = document.createElement('li');
				liNode.innerHTML = mrbgTools.rng.toHtml(rng);
				newNode.appendChild(liNode);
			})
			mrbgTools.rng.newNode(range, newNode);
			mrbgTools.rng.setCursorByNode(newNode);
		}
	}
	function changeOlType( e ){
		if( e.target.closest('ol') && e.shiftKey ){
			e.preventDefault();
			var
				types       = ['1', 'a', 'A', 'i', 'I'],
				ol          = e.target.matches('ol')? e.target: e.target.closest('ol'),
				currentType = ol.getAttribute('type');

			ol.setAttribute('type', types[( types.indexOf(currentType)+Math.round(e.deltaY/100) )%types.length]);
		}
	}
	function padding( e, operation ){
		e.preventDefault();
		var
			[range, parent] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm       = mrbgTools.rng.parentElement(parent);

		if( range == undefined || ( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') ) )
			return false;

		var
			rangeList  = mrbgTools.rng.getParagraph(range),
			p,
			continer,
			startNode,
			endNode,
			newNode    = document.createDocumentFragment(),
			targetNode = document.createElement('div'),
			br         = document.createElement('br');

		if( !rangeList.length )
			return false;

		function processP(){
			var gap = parseInt(p.style.paddingInlineStart || 0);
			gap     =
				operation == '+'?
				gap+30:
				Math.max(0, gap-30);

			if( gap || p.classList.length>1 ){
				gap?
					p.style.paddingInlineStart = gap+'px':               // ONLY CHANGE PADDING VALUE
					delete p.style.paddingInlineStart;                   // REMOVE PADDING STYLE
			}
			else{
				var frg = document.createDocumentFragment();
				while( p.firstChild )
					frg.appendChild(p.firstChild);
				p.replaceWith(frg);
			}
		}

		function createP(){
			var p = document.createElement('p');
			p.classList.add(TE_style.mrbgParag);
			p.style.paddingInlineStart = '30px';
			while( continer.firstChild )
				p.appendChild(continer.firstChild);
			continer.innerHTML = p.outerHTML;
		}

		for( var rng of rangeList ){
			targetNode.innerHTML = mrbgTools.rng.toHtml(rng);
			p                    = targetNode.querySelector('p');
			continer             = targetNode.querySelector('h3') || targetNode.querySelector('li') || targetNode;

			if( p )
				processP(p);
			else if( operation == '+' )
				createP(continer);

			while( targetNode.firstChild )
				newNode.appendChild(targetNode.firstChild);
		}

		if( newNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ){
			startNode = newNode.firstChild;
			endNode   = newNode.lastChild;
		}
		else{
			startNode = newNode;
			endNode   = newNode;
		}

		while( startNode.childNodes.length )
			startNode = startNode.childNodes[0];

		while( startNode.nodeName=='BR' && startNode.nextSibling )
			startNode = startNode.nextSibling;

		while( endNode.childNodes.length )
			endNode = endNode.childNodes[endNode.childNodes.length-1];

		mrbgTools.rng.newNode(range, newNode);

		let sel = window.getSelection();

		startNode.nodeName == '#text'?
			range.setStart(startNode, 0):
			range.setStartAfter(startNode);

		endNode.nodeName == '#text'?
			range.setEnd(endNode, endNode.textContent.length-1):
			range.setEndAfter(endNode);

		sel.removeAllRanges();
		sel.addRange(range);
	}
	function dir( e, className ){
		e.preventDefault();
		var
			[range, parent] = mrbgTools.rng.getRange(mrbgTE.current),
			parentElm       = mrbgTools.rng.parentElement(parent);

		if( range == undefined || ( parentElm !== mrbgTE.current && !parentElm.closest('[data-type="mrbgTextEditor"]') ) )
			return false;

		var
			rangeList  = mrbgTools.rng.getParagraph(range),
			p,
			continer,
			startNode,
			endNode,
			newNode    = document.createDocumentFragment(),
			targetNode = document.createElement('div'),
			br         = document.createElement('br');

		if( !rangeList.length )
			return false;
		function processP(){
			if(
				!p.classList.contains(TE_style[`mrbgTxt${className}`]) ||
				(
					className=='Justify' &&
					( p.classList.contains(TE_style.mrbgTxtLeft) || p.classList.contains(TE_style.mrbgTxtRight) || p.classList.contains(TE_style.mrbgTxtCenter) )
				) ||
				p.style.length
			){

				!p.classList.contains(TE_style[`mrbgTxt${className}`])?
					p.classList.add(TE_style[`mrbgTxt${className}`]):
					p.classList.remove(TE_style[`mrbgTxt${className}`]);

				if( className!=='Justify' )
					for( let c of ['Left','Right','Center'] )
						if( c !== className )
							p.classList.remove(TE_style[`mrbgTxt${c}`])
			}
			else{
				var frg = document.createDocumentFragment();
				while( p.firstChild )
					frg.appendChild(p.firstChild);
				p.replaceWith(frg);
			}
		}

		function createP(){
			var p = document.createElement('p');
			p.classList.add(TE_style.mrbgParag, TE_style[`mrbgTxt${className}`]);
			while( continer.firstChild )
				p.appendChild(continer.firstChild);
			continer.innerHTML = p.outerHTML;
		}

		for( var rng of rangeList ){
			targetNode.innerHTML = mrbgTools.rng.toHtml(rng);
			p                    = targetNode.querySelector('p');
			continer             = targetNode.querySelector('h3') || targetNode.querySelector('li') || targetNode;

			p?
				processP(p):
				createP(continer);

			while( targetNode.firstChild )
				newNode.appendChild(targetNode.firstChild);
		}

		if( newNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ){
			startNode = newNode.firstChild;
			endNode   = newNode.lastChild;
		}
		else{
			startNode = newNode;
			endNode   = newNode;
		}

		while( startNode.childNodes.length )
			startNode = startNode.firstChild;

		while( startNode.nodeName=='BR' && startNode.nextSibling )
			startNode = startNode.nextSibling;

		while( endNode.childNodes.length )
			endNode = endNode.lastChild;

		mrbgTools.rng.newNode(range, newNode);

		let sel = window.getSelection();

		startNode.nodeName == '#text'?
			range.setStart(startNode, 0):
			range.setStartAfter(startNode);

		endNode.nodeName == '#text'?
			range.setEnd(endNode, endNode.textContent.length-1):
			range.setEndAfter(endNode);

		sel.removeAllRanges();
		sel.addRange(range);
	}

	useEffect(() => {
	}, [content])
	useEffect(() => {
		const unsubscribe = mrbgStore.subscribe(() => {
			setRedFld(mrbgStore.getState().formsSettings[formID]?.redFld)
		})
		return () =>unsubscribe();
	}, []);

	return (
		<>
			<ul className={formStyle.mrbgTextEditorBtn}>
				<li>
					<div className={formStyle.mrbgCheckBox}>
						<input id={`${formID}GetTags`} type="checkbox" name="getTags" value="1" />
						<label htmlFor={`${formID}GetTags`} title="paste without filter"></label>
					</div>
					<button type="button" className={formStyle.changeTagBtn} onClick={e => {
						listening(e);
						return false;
					}} data-id="mrbgTE_mic">
						<i className={micCls}></i>
					</button>
				</li>
				<li>
					<button onClick={e => warpper(e, 'h3')} title="subtitle">
						<i className="fa fa-header"></i>
					</button>
					<button onClick={e => warpper(e, 'strong')} title="bold">
						<i className="fa fa-bold"></i>
					</button>
					<button onClick={e => warpper(e, 'em')} title="italic">
						<i className="fa fa-italic"></i>
					</button>
					<button onClick={e => spanWarpper(e, 'mrbgUnderScore')} title="underScore">
						<i className="fa fa-underline"></i>
					</button>
					<button onClick={e => spanWarpper(e, 'mrbgHighLight')} title="high light">
						<i className="fa fa-tag"></i>
					</button>
				</li>
				<li>
					<button onClick={e => handleInputFile(e)} title="add image">
						<i className="fa fa-image"></i>
					</button>
					<input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={e => extraImage(e)}
								 accept="image/*"/>
					<button onClick={e => icon(e)} title="text to icon">
						<i className="fa fa-info"></i>
					</button>
				</li>
				<li>
					<button onClick={e => linkTo(e, 'url')} title="create link">
						<i className="fa fa-link"></i>
					</button>
					<button onClick={e => linkTo(e, 'tel')} title="phone link">
						<i className="fa fa-phone"></i>
					</button>
					<button onClick={e => linkTo(e, 'mail')} title="image link">
						<i className="fa fa-envelope"></i>
					</button>
					<button onClick={e => unLink(e)} title="break link">
						<i className="fa fa-chain-broken"></i>
					</button>
				</li>
				<li>
					<button onClick={e => dir(e, 'Left')} title="left">
						<i className="fa fa-align-left"></i>
					</button>
					<button onClick={e => dir(e, 'Center')} title="center">
						<i className="fa fa-align-center"></i>
					</button>
					<button onClick={e => dir(e, 'Justify')} title="justify">
						<i className="fa fa-align-justify"></i>
					</button>
					<button onClick={e => dir(e, 'Right')} title="right">
						<i className="fa fa-align-right"></i>
					</button>
				</li>
				<li>
					<button onClick={e => listWarpper(e, 'ul')} title="unnumeric list">
						<i className="fa fa-list-ul"></i>
					</button>
					<button onClick={e => listWarpper(e, 'ol')} title="numeric list">
						<i className="fa fa-list-ol"></i>
					</button>
					<button onClick={e => padding(e, '+')} title="increase start gap">
						<i className="fa fa-indent"></i>
					</button>
					<button onClick={e => padding(e, '-')} title="decrease start gap">
						<i className="fa fa-outdent"></i>
					</button>
				</li>
			</ul>
			<div data-type="mrbgTextEditor" name={name}
					 className={`${formStyle.mrbgTextEditor} ${redFld.includes(name)? formStyle.emptyField: ''}`}
					 contentEditable={true} suppressContentEditableWarning={true} onPaste={e => stripTags(e)}
					 placeholder={placeholder} ref={mrbgTE} onKeyDown={e => keyDownHandler(e)}
					 onChange={e => setContent(e.target.innerHTML)}
			>
				{parse(content)}
			</div>
		</>
	)
}

export default MrbgTextEditor;